import {
  Box,
  Button,
  CircularProgress,
  Container,
  makeStyles,
  Paper,
  TextField,
} from "@material-ui/core";
import FormattedMessage from "features/common/TranslatedMessage";
import InlineError from "features/common/InlineError";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { isHotStar, isMuthoot, isStar } from "Routes/Routes";
import { forgotPassword } from "slices/loginSlice";
import { extractApiErrorMessage } from "utils/apiErrorMessage";
import * as Yup from "yup";
import React from "react";

const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email Required"),
});

const DEFAULT_ERROR = "Could not send the reset link. Please try again.";

const useStyles = makeStyles((theme) => {
  return {
    form: {
      width: "80%", // Fix IE 11 issue.
      marginTop: theme.spacing(1),
    },
    paper: {
      marginTop: theme.spacing(8),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "2rem",
    },

    loginButton: {
      margin: theme.spacing(3, 0, 2),
    },
    hoverButton: {
      background: "#3F51B5",
      color: "#FFFFFF",
      border: "1px solid transparent",
      "&:hover": {
        backgroundColor: "transparent",
        color: "#3F51B5",
        border: "1px solid #3F51B5",
      },
    },
  };
});

export default function PasswordReset() {
  const history = useHistory();
  const [error, setError] = React.useState();
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: ForgotPasswordSchema,
    onSubmit: async (values) => {
      setError();
      try {
        let result = await dispatch(forgotPassword(values.email.trim()));
        if (result?.status === "OK") {
          history.push("/forgot-password-confirm");
        } else {
          setError(extractApiErrorMessage(result, DEFAULT_ERROR));
        }
      } catch (err) {
        setError(extractApiErrorMessage(err, DEFAULT_ERROR));
      }
    },
  });

  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <Container component="main" maxWidth="sm">
      <Paper className={classes.paper}>
        <form
          className={classes.form}
          noValidate
          onSubmit={formik.handleSubmit}
        >
          <TextField
            variant="filled"
            margin="normal"
            value={formik.values.email}
            required
            fullWidth
            id="email"
            label={<FormattedMessage id="user.email" />}
            name="email"
            autoComplete="email"
            onBlur={formik.handleBlur}
            onChange={(e) => {
              formik.handleChange(e);
              setError();
            }}
          />
          <InlineError
            message={
              (formik.touched.email && formik.errors.email) || error || ""
            }
          />
          <Box height="1rem"></Box>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={formik.isSubmitting}
            className={`${classes.loginButton} ${(isHotStar || isStar || isMuthoot) && classes.hoverButton}`}
          >
            {formik.isSubmitting ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <FormattedMessage id="auth.paswordReset" />
            )}
          </Button>
        </form>
      </Paper>
    </Container>
  );
}
